import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import FixedPlugin from 'components/fixedPlugin/FixedPlugin';

const NotFound = () => {
    return (
        <div className="flex min-h-screen flex-col">
                    <FixedPlugin />
            <Header />
            <main className="flex-grow items-center justify-center bg-gray-50 dark:bg-navy-900">
                <div className="py-24 text-center">
                    <h1 className="text-6xl font-bold text-blue-600 dark:text-blue-400">404</h1>
                    <p className="mt-4 text-2xl font-semibold text-gray-800 dark:text-white">Page Not Found</p>
                    <p className="mt-2 text-gray-600 dark:text-gray-300">Sorry, the page you are looking for does not exist.</p>
                    <Link to="/" className="mt-6 inline-block rounded-md bg-blue-600 px-6 py-3 text-sm font-medium text-white shadow hover:bg-blue-700">
                        Go Back Home
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default NotFound;